// extracted by mini-css-extract-plugin
export var filterIncDec = "_bd-0";
export var leftBorder = "_bd-1";
export var rightBorder = "_bd-2";
export var stringInput = "_bd-3";